// import * as React from 'react';
// import PropTypes from 'prop-types';
// import Avatar from '@mui/material/Avatar';
// import Button from '@mui/material/Button';
// import Divider from '@mui/material/Divider';
// import Drawer, { drawerClasses } from '@mui/material/Drawer';
// import Stack from '@mui/material/Stack';
// import Typography from '@mui/material/Typography';
// import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
// import NotificationsRoundedIcon from '@mui/icons-material/NotificationsRounded';
// import MenuButton from './MenuButton';
// import MenuContent from './MenuContent';
// import { removeToken } from '../../Services/LocalStorageService';
// import { useNavigate } from 'react-router-dom';

// function SideMenuMobile({ open, toggleDrawer }) {
//   const navigate = useNavigate();

//   const handleLogout = () => {
//     removeToken();
//     navigate('/');
//     toggleDrawer(false)();
//   };

//   // ✅ Menu item click होने पर drawer बंद करें
//   const handleMenuItemClick = () => {
//     toggleDrawer(false)();
//   };

//   return (
//     <Drawer
//       anchor="right"
//       open={open}
//       onClose={toggleDrawer(false)}
//       sx={{
//         zIndex: (theme) => theme.zIndex.drawer + 1,
//         [`& .${drawerClasses.paper}`]: {
//           backgroundImage: 'none',
//           backgroundColor: 'background.paper',
//         },
//       }}
//     >
//       <Stack
//         sx={{
//           maxWidth: '70dvw',
//           height: '100%',
//         }}
//       >
//         {/* Sticky Header */}
//         <Stack
//           direction="row"
//           sx={{
//             p: 2,
//             pb: 0,
//             gap: 1,
//             position: 'sticky',
//             top: 0,
//             zIndex: (theme) => theme.zIndex.appBar + 1,
//             backgroundColor: 'background.paper',
//           }}
//         >
//           <Stack
//             direction="row"
//             sx={{ gap: 1, alignItems: 'center', flexGrow: 1, p: 1 }}
//           >
//             <Avatar
//               sizes="small"
//               alt="Riley Carter"
//               src="/static/images/avatar/7.jpg"
//               sx={{ width: 24, height: 24 }}
//             />
//             <Typography component="p" variant="h6">
//               {localStorage.getItem('name')}
//             </Typography>
//           </Stack>

//           <MenuButton showBadge>
//             <NotificationsRoundedIcon />
//           </MenuButton>
//         </Stack>

//         <Divider />

//         {/* ✅ MenuContent को onItemClick prop pass करें */}
//         <Stack sx={{ flexGrow: 1 }}>
//           <MenuContent onItemClick={handleMenuItemClick} />
//           <Divider />
//         </Stack>

//         <Stack sx={{ p: 2 }}>
//           <Button
//             variant="outlined"
//             fullWidth
//             startIcon={<LogoutRoundedIcon />}
//             onClick={handleLogout}
//           >
//             Logout
//           </Button>
//         </Stack>
//       </Stack>
//     </Drawer>
//   );
// }

// SideMenuMobile.propTypes = {
//   open: PropTypes.bool,
//   toggleDrawer: PropTypes.func.isRequired,
// };

// export default SideMenuMobile;












import * as React from 'react';
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Drawer, { drawerClasses } from '@mui/material/Drawer';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import NotificationsRoundedIcon from '@mui/icons-material/NotificationsRounded';
import BusinessIcon from '@mui/icons-material/Business';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Chip from '@mui/material/Chip';
import Box from '@mui/material/Box';
import MenuButton from './MenuButton';
import MenuContent from './MenuContent';
import { removeToken } from '../../Services/LocalStorageService';
import { useNavigate } from 'react-router-dom';
import { DivisionList } from '../../Services/Services';
import { storeDivision } from '../../Services/LocalStorageService';

function SideMenuMobile({ open, toggleDrawer }) {
  const navigate = useNavigate();
  const [divisions, setDivisions] = useState([]);
  const [selectedDivision, setSelectedDivision] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const openDivisionMenu = Boolean(anchorEl);

  // Fetch divisions and load saved division
  useEffect(() => {
    const divisionData = localStorage.getItem('selectedDivision');
    if (divisionData) {
      try {
        setSelectedDivision(JSON.parse(divisionData));
      } catch (e) {
        console.error('Error parsing division data:', e);
      }
    }
    fetchDivisions();
  }, []);

  const fetchDivisions = async () => {
    try {
      const response = await DivisionList();
      setDivisions(response.data || response);
    } catch (err) {
      console.error('Error fetching divisions:', err);
    }
  };

  const handleLogout = () => {
    removeToken();
    navigate('/');
    toggleDrawer(false)();
  };

  // Menu item click – close drawer
  const handleMenuItemClick = () => {
    toggleDrawer(false)();
  };

  // Division menu handlers
  const handleChangeDivision = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseDivisionMenu = () => {
    setAnchorEl(null);
  };

  const handleDivisionSelect = (division) => {
    setSelectedDivision(division);
    storeDivision(division);
    localStorage.setItem('selectedDivision', JSON.stringify(division));
    setAnchorEl(null);
    // Reload page after division change
    setTimeout(() => {
      window.location.reload();
    }, 300);
  };

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={toggleDrawer(false)}
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        [`& .${drawerClasses.paper}`]: {
          backgroundImage: 'none',
          backgroundColor: 'background.paper',
        },
      }}
    >
      <Stack
        sx={{
          maxWidth: '70dvw',
          height: '100%',
        }}
      >
        {/* Sticky Header */}
        <Stack
          direction="row"
          sx={{
            p: 2,
            pb: 0,
            gap: 1,
            position: 'sticky',
            top: 0,
            zIndex: (theme) => theme.zIndex.appBar + 1,
            backgroundColor: 'background.paper',
          }}
        >
          <Stack
            direction="row"
            sx={{ gap: 1, alignItems: 'center', flexGrow: 1, p: 1 }}
          >
            <Avatar
              sizes="small"
              alt="Riley Carter"
              src="/static/images/avatar/7.jpg"
              sx={{ width: 24, height: 24 }}
            />
            <Typography component="p" variant="h6">
              {localStorage.getItem('name')}
            </Typography>
          </Stack>

          <MenuButton showBadge>
            <NotificationsRoundedIcon />
          </MenuButton>
        </Stack>

        <Divider />

        {/* Division Section - Mobile */}
        <Box sx={{ mx: 1, my: 1 }}>
          {selectedDivision ? (
            <Box
              sx={{
                p: 1.5,
                borderRadius: 2,
                background: (theme) =>
                  `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
                color: 'white',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <BusinessIcon sx={{ fontSize: 20 }} />
                <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                  {selectedDivision.division}
                </Typography>
              </Box>
              <Tooltip title="Change Division" arrow>
                <IconButton
                  size="small"
                  onClick={handleChangeDivision}
                  sx={{
                    color: 'white',
                    backgroundColor: 'rgba(255,255,255,0.2)',
                    '&:hover': {
                      backgroundColor: 'rgba(255,255,255,0.3)',
                      transform: 'rotate(180deg)',
                    },
                    transition: 'all 0.3s ease',
                    width: 28,
                    height: 28,
                  }}
                >
                  <SwapHorizIcon sx={{ fontSize: 16 }} />
                </IconButton>
              </Tooltip>
            </Box>
          ) : (
            <Box
              sx={{
                p: 1.5,
                borderRadius: 2,
                border: '2px dashed',
                borderColor: 'warning.main',
                backgroundColor: 'warning.lighter',
                textAlign: 'center',
              }}
            >
              <BusinessIcon sx={{ fontSize: 28, color: 'warning.main', mb: 0.5 }} />
              <Typography variant="caption" sx={{ display: 'block', color: 'warning.dark', fontWeight: 500 }}>
                No Division Selected
              </Typography>
              <Chip
                label="Select Division"
                size="small"
                icon={<SwapHorizIcon sx={{ fontSize: 14 }} />}
                onClick={handleChangeDivision}
                sx={{
                  cursor: 'pointer',
                  backgroundColor: 'warning.main',
                  color: 'white',
                  '&:hover': { backgroundColor: 'warning.dark' },
                  mt: 0.5,
                }}
              />
            </Box>
          )}
        </Box>

        {/* Division Selection Menu */}
        <Menu
          anchorEl={anchorEl}
          open={openDivisionMenu}
          onClose={handleCloseDivisionMenu}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          PaperProps={{
            sx: {
              width: 230,
              maxHeight: 330,
              mt: 1,
              borderRadius: 3,
              overflow: 'hidden',
              border: '1px solid rgba(0,0,0,0.08)',
              boxShadow: '0 12px 35px rgba(0,0,0,0.18)',
              background: 'linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)',
            },
          }}
        >
          <Box
            sx={{
              px: 2,
              py: 1.5,
              background: (theme) =>
                `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
              color: 'white',
            }}
          >
            <Typography sx={{ fontSize: '0.8rem', fontWeight: 700 }}>
              Change Division
            </Typography>
            <Typography sx={{ fontSize: '0.68rem', opacity: 0.85 }}>
              Select your working division
            </Typography>
          </Box>
          <Box sx={{ maxHeight: 260, overflowY: 'auto', py: 0.5 }}>
            {divisions.length > 0 ? (
              divisions.map((item) => {
                const isSelected = selectedDivision?.division_id === item.division_id;
                return (
                  <MenuItem
                    key={item.division_id}
                    selected={isSelected}
                    onClick={() => handleDivisionSelect(item)}
                    sx={{
                      mx: 1,
                      my: 0.5,
                      borderRadius: 2,
                      fontSize: '0.85rem',
                      fontWeight: isSelected ? 700 : 500,
                      color: isSelected ? 'primary.main' : 'text.primary',
                      backgroundColor: isSelected ? 'rgba(25, 118, 210, 0.08)' : 'transparent',
                      '&:hover': {
                        backgroundColor: 'rgba(25, 118, 210, 0.12)',
                        transform: 'translateX(3px)',
                      },
                      transition: 'all 0.2s ease',
                    }}
                  >
                    <BusinessIcon
                      sx={{
                        fontSize: 18,
                        mr: 1,
                        color: isSelected ? 'primary.main' : 'text.secondary',
                      }}
                    />
                    <Box sx={{ flex: 1 }}>{item.division}</Box>
                    {isSelected && (
                      <Typography sx={{ fontSize: '0.7rem', fontWeight: 700 }}>
                        Active
                      </Typography>
                    )}
                  </MenuItem>
                );
              })
            ) : (
              <MenuItem disabled>No divisions found</MenuItem>
            )}
          </Box>
        </Menu>

        <Divider />

        {/* Scrollable Menu Content */}
        <Stack sx={{ flexGrow: 1 }}>
          <MenuContent onItemClick={handleMenuItemClick} />
          <Divider />
        </Stack>

        {/* Logout Button */}
        <Stack sx={{ p: 2 }}>
          <Button
            variant="outlined"
            fullWidth
            startIcon={<LogoutRoundedIcon />}
            onClick={handleLogout}
          >
            Logout
          </Button>
        </Stack>
      </Stack>
    </Drawer>
  );
}

SideMenuMobile.propTypes = {
  open: PropTypes.bool,
  toggleDrawer: PropTypes.func.isRequired,
};

export default SideMenuMobile;